import { render, staticRenderFns } from "./CentralPaperMonitor.vue?vue&type=template&id=ca014ff4&scoped=true"
import script from "./CentralPaperMonitor.vue?vue&type=script&lang=js"
export * from "./CentralPaperMonitor.vue?vue&type=script&lang=js"
import style0 from "./CentralPaperMonitor.vue?vue&type=style&index=0&id=ca014ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca014ff4",
  null
  
)

export default component.exports